<sol-text-field
  [prependIcon]="SolIcon.search"
  [appendIcon]="!value$() ? undefined : SolIcon.remove"
  [appendIconClickable]="!!value$()"
  [loading]="loading$()"
  [disabled]="disabled$()"
  [immediate]="immediate$()"
  [hasError]="hasError$()"
  [value]="value$()"
  (value)="onSearch($event)"
  (clickIcon)="onSearchClear()"
  (keydown.escape)="onSearchClear()"
  (focused)="onFocused($event)"
></sol-text-field>
